import React, { useContext, useEffect, useState } from "react";
import UserItem from "./userItem";
// import UserDetailsModel from "./userDetailsModel";
import UserAddModel from "./userAddModel";
import UserViewModel from "./userViewModel";
import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-number-input/style.css";
import TopLoadingBar from "../topLoadingBar/topLoadingBar";
import { ERROR_CODE } from "../../constant";
import UserContext from "../../context/userContext";
import {
  CreateUser,
  UserDetail,
  UpdateUser,
  UserHisabList,
  DeleteUser,
  ChangeUserStatus,
} from "../../api/Users Api/UserApi";
import { Temple_Trust_List } from "../../api/TempleTrustApi/TempleTrustApi";
import { BankMasterList } from "../../api/Bank Master api/BankMasterAPi";
import OrganizationContext from "../../context/OrganizationContext/OrganizationContext";
import LogOut from "../../utils/logout";
import { useNavigate } from "react-router";

const Users = () => {
  const {
    setData,
    setahoeDataModel,
    setModal,
    modal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    filter,
    editIndex,
    seteditIndex,
    userId,
    setUserId,
    setIsAddHandle,
    progress,
    setProgress,
    togglesubmit,
    setToggle,
    setShowHanlde,
    trustIds,
    setTrustIds,
    bankIds,
    setBankIds,
  } = useContext(UserContext);

  const { loaderShow, setLoaderShow, responseLoader, setResponseLoader } =
    useContext(OrganizationContext);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const [error, setError] = useState(false);
  const history = useNavigate();

  const [viewModal, setViewModal] = useState(false);
  const [viewUserData, setViewUserData] = useState(null);
  const viewToggle = () => setViewModal(!viewModal);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [roleId, setRoleId] = useState("");

  const [trustList, setTrustList] = useState([]);
  const [bankList, setBankList] = useState([]);

  const getAccessData = async () => {
    try {
      const { data: trusts } = await Temple_Trust_List({ showAll: true });
      if (trusts.status === 200) {
        setTrustList(trusts.payload.data.map(t => ({ value: +t.trustId, label: t.trustName })));
      }
    } catch (error) {
      console.error("Error fetching access data", error);
    }
  };

  const getBankByTrusts = async (selectedTrustIds) => {
    try {
      if (selectedTrustIds.length === 0) {
        setBankList([]);
        return;
      }
      // If the API supports multiple IDs in search, we can pass them all.
      // Assuming it handles array for trustId.
      let paramsObj = {
        showAll: true,
        search: JSON.stringify({ trustId: selectedTrustIds, isActive: true })
      };
      const { data: banks } = await BankMasterList(paramsObj);
      if (banks.status === 200) {
        setBankList(banks.payload.data.map(b => ({ value: +b.bankId, label: b.name, trustId: +b.trustId })));
      }
    } catch (error) {
      console.error("Error fetching banks by trust", error);
    }
  };

  const getData = async () => {
    if (sortOrder === "ASC" || sortOrder === "DSC" || filter.length) {
    } else {
      setResponseLoader(!responseLoader);
    }
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy,
      };
      if (filter.length) {
        paramsObj["search"] = JSON.stringify({ name: filter });
      }
      const { data } = await UserHisabList(paramsObj);
      if (data.status === 200) {
        setData(data.payload.data);
        setRecord(data.pager.totalRecords);
        setResponseLoader(false);
      } else {
        setData([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      setResponseLoader(false);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  useEffect(() => {
    getData();
  }, [page, pageSize, sortOrder, sortBy, filter]);

  useEffect(() => {
    setProgress(100);
    getAccessData();
  }, []);

  const EmptyField = () => {
    setName("");
    setEmail("");
    setPhone("");
    setPassword("");
    setconfirmPassword("");
    setRoleId("");
    setTrustIds([]);
    setBankIds([]);
    setError(false);
    setLoaderShow(false);
  };

  const AddModel = () => {
    setModal(true);
    setToggle(true);
    seteditIndex(-1);
    EmptyField();
  };

  const editHandle = async (id) => {
    setUserId(id);
    setLoaderShow(!loaderShow);
    try {
      const { data } = await UserDetail(id);
      if (data.status === 200) {
        setToggle(false);
        setIsAddHandle(false);
        seteditIndex(id);
        const payload = data.payload;
        setName(payload.name || "");
        setEmail(payload.email || "");
        setPhone(payload.phone || "");
        setRoleId(payload.roleId || "");
        const selectedTrusts = payload.userRoleDetails?.userTrustLinks?.map(l => +l.trustId) || [];
        setTrustIds(selectedTrusts);
        setBankIds(payload.userRoleDetails?.userBankLinks?.map(l => +l.bankId) || []);
        getBankByTrusts(selectedTrusts);
        setLoaderShow(false);
        setModal(true);
      } else {
        // setData([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (
      togglesubmit
        ? name.length === 0 ||
          email.length === 0 ||
          phone.length === 0 ||
          password.length === 0 ||
          password !== confirmPassword
        : name.length === 0 || email.length === 0 || phone.length === 0
    ) {
      setError(true);
    } else {
      setLoaderShow(!loaderShow);
      try {
        let formData = {
          name,
          email,
          phone,
          roleId,
          trustIds,
          bankIds,
        };
        if (togglesubmit) {
          formData.password = password;
          formData.confirmPassword = confirmPassword;
        } else {
          formData.userId = userId;
        }

        const { data } = togglesubmit
          ? await CreateUser(formData)
          : await UpdateUser(formData);

        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom,
          });
          getData();
          setModal(false);
          EmptyField();
        } else {
          setLoaderShow(false);
        }
      } catch (error) {
        if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
          LogOut(history);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom,
        });
        setLoaderShow(false);
      }
    }
  };

  const sorting = (sortModel) => {
    if (sortModel && sortModel.length > 0) {
      setSortBy(sortModel[0].field);
      setSortOrder(sortModel[0].sort.toUpperCase());
    } else {
      setSortBy("createdAt");
      setSortOrder("ASC");
    }
  };

  const handleFilter = (e) => {
    // filter logic already handled by useEffect and filter state
  };

  const close = () => {
    setModal(!modal);
    EmptyField();
  };

  const deleteHandle = async (id) => {
    const loggedInUserId = localStorage.getItem("userId");
    if (Number(id) === Number(loggedInUserId)) {
      toast.error("You cannot delete your own account.", { autoClose: 2000, transition: Zoom });
      return;
    }
    if (window.confirm("Are you sure you want to delete this user?")) {
      setLoaderShow(true);
      try {
        const { data } = await DeleteUser(id);
        if (data.status === 200) {
          toast.success(data.message, { autoClose: 1000, transition: Zoom });
          getData();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message, { autoClose: 1000, transition: Zoom });
      } finally {
        setLoaderShow(false);
      }
    }
  };

  const statusHandle = async (id, status) => {
    const loggedInUserId = localStorage.getItem("userId");
    if (Number(id) === Number(loggedInUserId) && status === 0) {
      toast.error("You cannot deactivate your own account.", { autoClose: 2000, transition: Zoom });
      return;
    }
    setLoaderShow(true);
    try {
      const { data } = await ChangeUserStatus({ userId: id, isActive: status });
      if (data.status === 200) {
        toast.success(data.message, { autoClose: 1000, transition: Zoom });
        getData();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, { autoClose: 1000, transition: Zoom });
    } finally {
      setLoaderShow(false);
    }
  };

  const showHandle = async (id) => {
    setLoaderShow(true);
    try {
      const { data } = await UserDetail(id);
      if (data.status === 200) {
        setViewUserData(data.payload);
        setViewModal(true);
      }
    } catch (error) {
      toast.error("Failed to load user details", { autoClose: 2000, transition: Zoom });
    } finally {
      setLoaderShow(false);
    }
  };

  return (
    <>
      <div>
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <UserAddModel
          onSubmit={onSubmit}
          close={close}
          error={error}
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          phone={phone}
          setPhone={setPhone}
          password={password}
          setPassword={setPassword}
          confirmPassword={confirmPassword}
          setconfirmPassword={setconfirmPassword}
          roleId={roleId}
          setRoleId={setRoleId}
          togglesubmit={togglesubmit}
          trustIds={trustIds}
          setTrustIds={setTrustIds}
          bankIds={bankIds}
          setBankIds={setBankIds}
          trustList={trustList}
          bankList={bankList}
          getBankByTrusts={getBankByTrusts}
        />
        <UserItem
          handleFilter={handleFilter}
          sorting={sorting}
          editHandle={editHandle}
          showHandle={showHandle}
          deleteHandle={deleteHandle}
          statusHandle={statusHandle}
          AddModel={AddModel}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
        />
      </div>
      <UserViewModel
        modal={viewModal}
        toggle={viewToggle}
        userData={viewUserData}
      />
    </>
  );
};

export default Users;
